/**
 * Aviso de venta sin terminar (ver lib/borradorventa): quién/qué chasis,
 * hace cuánto, y los botones Continuar / Descartar.
 */
import React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { FP } from "components/financepro";
import { haceCuanto, textoResumenBorrador } from "lib/borradorventa";

const btn = { textTransform: "none", fontWeight: 700, borderRadius: 1.6, boxShadow: "none" };

export default function AvisoBorradorVenta({ borrador, etiqueta, onContinuar, onDescartar, sx }) {
  if (!borrador) return null;
  return (
    <Alert
      severity="info"
      sx={{ borderRadius: 2, alignItems: "center", ...sx }}
      action={
        <Stack direction="row" spacing={1}>
          <Button size="small" onClick={onDescartar} sx={{ ...btn, color: FP.color.textSecondary }}>
            Descartar
          </Button>
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={onContinuar}
            sx={{
              ...btn,
              bgcolor: FP.color.navy,
              color: "#FFFFFF",
              "&:hover": { bgcolor: FP.color.navySoft, color: "#FFFFFF" },
            }}
          >
            Continuar
          </Button>
        </Stack>
      }
    >
      Tienes una {etiqueta} sin terminar: <b>{textoResumenBorrador(borrador.resumen)}</b> (
      {haceCuanto(borrador.guardado)})
    </Alert>
  );
}

AvisoBorradorVenta.propTypes = {
  borrador: PropTypes.shape({
    guardado: PropTypes.number,
    resumen: PropTypes.shape({
      cliente: PropTypes.string,
      chasis: PropTypes.string,
      detalle: PropTypes.string,
    }),
  }),
  etiqueta: PropTypes.string.isRequired,
  onContinuar: PropTypes.func.isRequired,
  onDescartar: PropTypes.func.isRequired,
  sx: PropTypes.shape({}),
};

AvisoBorradorVenta.defaultProps = { borrador: null, sx: undefined };
